import { MessengerThemeLayoutType } from "../store/messenger/types";

export const STORAGE_TOKEN = "auth_key";
export const STORAGE_USER_PREF = "user_pref";
export const STORAGE_AUTHOR_HASH = "authorHash";
export const STORAGE_THEME = "theme";
export const STORAGE_USER_ID = "user_id";
export const STORAGE_CURRENT_ROOM = "current_room";
export const STORAGE_NOTIFICATION_OPTION = "notification_options";
export const STORAGE_CHAT_SETTINGS = "chat_settings";
export const STORAGE_MEDIA_SETTING = "media_storage_setting";
export const STORAGE_ACTIVE_INDEX_GALLERY = "active_index_gallery";
export const STORAGE_LANG = "i18nextLng";
export const STORAGE_USER_LOCATION = "user_location";
export const STORAGE_SET_ACTION_ID = "set_action_id";
export const STORAGE_AUDIO_ROOM_ID = "audio_room_id";
export const STORAGE_LOCATION_PERMISSION_STATUS = "location_status";
export const STORAGE_AI_ACCESS_TOKEN = "ai_access";
export const STORAGE_AI_REFRESH_TOKEN = "ai_refresh";
export const STORAGE_A2HS = "a2hs";

export const MAIN_STORAGES = [STORAGE_TOKEN, STORAGE_AUTHOR_HASH, STORAGE_USER_ID];

export type NotificationStorageOptionType = {
  enabled: boolean;
  sound: boolean;
  preview: boolean;
};

export type ChatSettingsStorageType = {
  hour_24: boolean;
  show_channel_vote_layout: boolean;
  show_sender_name_in_groups: boolean;
  send_by_enter_key: boolean;
  play_message_sound_in_chat: boolean;
  play_Message_Text_To_Voice: boolean;
  in_app_browser: boolean;
  trim_video: boolean;
  compress_video: boolean;
  open_video_with_default_player: boolean;
  crop_and_resize_photo: boolean;
  small_camera_in_attachments: boolean;
  date_item: string;
  chat_font_size: number;
  theme_layout: MessengerThemeLayoutType;
};
